import { Injectable } from '@angular/core';
import { ApiService, } from './api.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { Profile } from '../models/index';

import { updateResponse } from './api.service';

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class ProfileService extends ApiService<Profile> {

	protected apiName: string = 'profile';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	addNewProfile(name: string): Observable<updateResponse<Profile>> {
		return this.http.post<updateResponse<Profile>>(
			this.getBaseUrl('addnewprofile'),
			{
				name: name
			}
		);
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/profile.service.ts